const locale = require('./formSummaryGridDetail.i18n.json');

/*@ngInject*/
const FormSummaryGridDetailController = function ($scope, $state, $stateParams, $timeout, preferenceModel, coreConstant, formViewerConstant, formMediator, modalUtil, coreMediator, effectiveDate, currencyCode, printable) {

    let timeoutList = [];

    $scope.i18n = locale.formSummaryGridDetail;
    $scope.submissionId = parseInt($stateParams.submissionId);

    $scope.viewModel = {
        formIsLoaded: false,
        parentFormId: $stateParams.formId,
        parentFormName: '',
        formSummaryInstanceId: $stateParams.formSummaryInstanceId,
        formSummaryInstanceOwnerUri: 'com.firstbest.underwriting.form.Form:' + $stateParams.ownerUriId,
        addFormInstanceFunctionButtonExecutorName: '',
        isWaitingForServerResponse: false,
        formTemplateName: '',
        formInstanceList: [],
        selectedFormInstance: null,
        enableDelete: false,
        enableAdd: false,
        options: {},
        submissionId: $stateParams.submissionId,
        effectiveDate: effectiveDate.get(),
        currencyCode: currencyCode.get(),
        printable: printable.get(),
        dynamicFormNameDataSetName: 'Dynamic Form Names With Ids'
    };

    function loadAddDeletePermissionConfig() {
        let formId = $stateParams.formId,
            formSummaryInstanceId = $stateParams.formSummaryInstanceId;

        formMediator.getFormSummaryAddDeleteConfigByFormSummaryInstanceId(formId, formSummaryInstanceId).then(function (result) {
            $scope.viewModel.enableAdd = result.enableAdd;
            $scope.viewModel.enableDelete = result.enableDelete;
            $scope.viewModel.addFormInstanceFunctionButtonExecutorName = result.addFormInstanceFunctionButtonExecutorName;
            $scope.viewModel.formTemplateName = result.formTemplateName;
        });
    }

    function loadFormInstances() {
        const params = {
            name: $scope.viewModel.dynamicFormNameDataSetName,
            ownerUri: $scope.viewModel.formSummaryInstanceOwnerUri
        };

        if (!_.isNil($stateParams.submissionId)) {
            params.submissionUri = 'com.firstbest.underwriting.submission.Submission:' + $stateParams.submissionId;
        }

        coreMediator.getDynamicDataSetItems(params, $stateParams.formId).then(function (result) {
            $scope.viewModel.formInstanceList = result;
            $scope.viewModel.selectedFormInstance = _.find(result, {value: $scope.viewModel.formSummaryInstanceId});
        });
    }

    function loadParentFormInstance() {
        formMediator.getFormInstanceById($scope.viewModel.parentFormId).then(function (result) {
            $scope.viewModel.parentForm = result;
            $scope.viewModel.parentFormName = $scope.viewModel.parentForm.formTemplateDisplayName;
        });
    }

    $scope.onChangeFormInstance = function (selectedForm) {
        let newFormInstanceId = selectedForm.value;
        $state.go(
            $state.current.name,
            {formSummaryInstanceId: newFormInstanceId},
            {notify: true}
        );
        $scope.viewModel.formSummaryInstanceId = newFormInstanceId;
    };

    $scope.onGoToParentForm = function () {
        $state.go('^.form', {formId: $scope.viewModel.parentFormId});
    };

    $scope.updateItems = function (updateEvent, data) {

    };

    $scope.createNewFormInstance = function () {
        let detailScreenOwnerUri = $stateParams.ownerUriId,
            parentFormId = $scope.viewModel.parentFormId,
            submissionId = parseInt($stateParams.submissionId),
            formTemplateName = $scope.viewModel.formTemplateName,
            addFormInstanceFunctionButtonExecutorName = $scope.viewModel.addFormInstanceFunctionButtonExecutorName;

        $scope.viewModel.isWaitingForServerResponse = true;

        formMediator.addFormSummaryRow(parentFormId, submissionId, formTemplateName, addFormInstanceFunctionButtonExecutorName).then(function (result) {
            $state.go('^.formSummaryGridDetail',
                {
                    formId: $stateParams.formId,
                    ownerUriId: detailScreenOwnerUri,
                    formSummaryInstanceId: result.id
                }
            );

            $scope.viewModel.isWaitingForServerResponse = false;
        });
    };

    $scope.deleteFormInstance = function () {
        let config = {
            cancelButtonLabel: $scope.i18n.cancel,
            confirmActionButtonLabel: $scope.i18n.confirm,
            summary: $scope.i18n.deleteSingleForm,
            title: $scope.i18n.deleteSingleFormTitle
        };

        modalUtil.showGenericConfirm(config).then(function () {
            formMediator.deleteFormSummaryRow([$stateParams.formSummaryInstanceId]).then(function () {
                $scope.onGoToParentForm();
            });
        });
    };

    $scope.$on(coreConstant.event.UPDATE_DATA_SET, function (event, data) {
        timeoutList.push($timeout(function () {
            if ($scope.viewModel.formSummaryInstanceOwnerUri === data.dynamicDataSetKey.ownerUri && data.name === $scope.viewModel.dynamicFormNameDataSetName) {
                $scope.viewModel.formInstanceList = data.items;
                $scope.viewModel.selectedFormInstance = _.find(data.items, {value: $scope.viewModel.formSummaryInstanceId});
            }
        }, 0));
    });

    $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function (event, inst) {
        timeoutList.push($timeout(function () {
            $scope.datagrid = inst;
        }, 0));
    });

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });

    $scope.$on(formViewerConstant.event.FORM_DATA_READY, function (event, formData, rootFormId) {
        let formSummaryInstanceId = $stateParams.formSummaryInstanceId,
            dynamicFormNameDataSetName = formData.uiFormTemplate.formTemplate.dynamicFormNameDataSetName;

        if (formSummaryInstanceId === rootFormId) {
            if (!_.isNil(dynamicFormNameDataSetName) && !_.isEmpty(dynamicFormNameDataSetName)) {
                $scope.viewModel.dynamicFormNameDataSetName = dynamicFormNameDataSetName;
            }

            loadAddDeletePermissionConfig();
            loadFormInstances();
            loadParentFormInstance();
        }
    });
};

angular.module('umFormViewer')
    .controller('formSummaryGridDetailController', FormSummaryGridDetailController);
